import {Injectable, EventEmitter} from '@angular/core';
import {Constants} from "./constants";
import {HttpApiService} from "./http-api.service";
import {EndpointsService} from "./endpoints.service";

@Injectable()
export class ProfilesService {
  private profiles: any = null;
  private allProfiles: any;
  private bucketUrl: string = Constants.BUCKET_URL();
  private searchText: string;
  private resellerPrograms: Array<any>;
  private profileUpdateEvent = new EventEmitter();
  private categories: any = null;
  private categoryUpdatedEvent = new EventEmitter();
  private allProfilesUpdateEvent = new EventEmitter();

  constructor(private Api: HttpApiService,
              private endpoints: EndpointsService) {
    this.getProfiles();
    this.getCategories();
  }

  getProfiles() {
    if (this.profiles) {
      this.profileUpdateEvent.emit(this.profiles);
      return;
    }
    this.Api.get(this.endpoints.getProfileUrl("domain=" + Constants.TENANT_ID()))
      .subscribe(response => {
        this.profiles = response;
        this.allProfiles = response;
        this.profileUpdateEvent.emit(this.profiles);
      });
  }

  getAllProfiles() {
    if (this.allProfiles) {
      this.allProfilesUpdateEvent.emit(this.allProfiles);
      return;
    }
    this.Api.get(this.endpoints.getProfileUrl(`max=-1&domain=${Constants.TENANT_ID()}`)).subscribe(response => {
      this.allProfiles = response;
      this.allProfilesUpdateEvent.emit(this.allProfiles);
    });
  }

  getProfileById(id: number) {
    let profile = {};
    if (!this.allProfiles) {
      return profile;
    }

    for (let i = 0; i < this.allProfiles.length; i++) {
      if (this.allProfiles[i].id == id) {
        profile = this.allProfiles[i];
        break;
      }
    }
    return profile;
  }

  getCategories() {
    if (this.categories) {
      this.categoryUpdatedEvent.emit(this.categories);
      return;
    }
    this.Api.get(this.endpoints.getApplicationCategoryUrl("domain=" + Constants.TENANT_ID()))
      .subscribe(response=> {
        this.categories = response;
        this.categoryUpdatedEvent.emit(this.categories);
      })
  }

  searchProfile(text: string) {
    if (text && text.length > 1 && text != this.searchText) {
      this.Api.get(this.endpoints.getProfileUrl("tenantId=" + Constants.TENANT_ID() + "&name=" + text))
        .subscribe(response=> {
          this.profiles = response;
          this.profileUpdateEvent.emit(this.profiles);
        })
    }
    else if (text == "") {
      this.profiles = this.allProfiles;
      this.profileUpdateEvent.emit(this.profiles);
    }
    this.searchText = text;
  }

  subscribeForProfiles() {
    return this.profileUpdateEvent;
  }

  subscribeForCategories() {
    return this.categoryUpdatedEvent;
  }

  clearCategories() {
    this.categories = null;
  }

  clearProfiles() {
    this.profiles = null;
  }


  incrementProfileViews(profileId: number) {
    this.Api.put(this.endpoints.getincrementProfileViewsUrl("profileId=" + profileId), null)
      .subscribe(response=> {
        console.log("p count: ", response);
      })
  }

  public getResellerPrograms() {
    let self = this;
    return new Promise((resolve) => {
      if(self.resellerPrograms && self.resellerPrograms.length > 0) {
        resolve(self.resellerPrograms);
      }

      self.Api.get(this.endpoints.getResellerProgramsUrl())
        .subscribe(results => {
            self.resellerPrograms = results;
            resolve(self.resellerPrograms);
          },
          error => {
            console.log(error);
          });
    });
  };
}



// WEBPACK FOOTER //
// ./src/app/services/profiles.service.ts